import {IconProp} from "@fortawesome/fontawesome-svg-core"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {IconDefinition} from "@fortawesome/fontawesome-common-types"
import {faAnglesRight, faCheck, faChevronDown, faChevronRight,faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'
import React, {PropsWithChildren, useCallback, useEffect, useState, forwardRef, useRef, useMemo} from "react"
import {Link} from "react-router-dom"
import FocusTrap from "focus-trap-react"
import * as RP from "@radix-ui/react-popover"
import {Command as Cmdk} from "cmdk"

export const Eres_toggle_do_not_use_yet = ({id, defaultChecked} : {id : string, defaultChecked : boolean}) => {
    const [checked, set_checked] = useState(defaultChecked)
    const toggle_cb = useCallback((evt : MouseEvent) => {evt.preventDefault(); set_checked(!checked)}, [checked])

    const bg = checked ? "tw-bg-indigo-600" : "tw-bg-gray-200"
    const anim = checked ? "tw-translate-x-5" : "tw-translate-x-0"

    return (
        <button type="button" id={id} className="tw-group tw-relative tw-inline-flex tw-h-5 tw-w-10 tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-600 focus:tw-ring-offset-2" role="switch" aria-checked={checked}>
        <span className="tw-sr-only">Use setting</span>
        <span aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-h-full tw-w-full tw-rounded-md tw-bg-white"></span>
        <span aria-hidden="true" className={`${bg} tw-pointer-events-none tw-absolute tw-mx-auto tw-h-4 tw-w-9 tw-rounded-full tw-transition-colors tw-duration-200 tw-ease-in-out`}></span>
        <span aria-hidden="true" className={`${anim} tw-pointer-events-none tw-absolute tw-left-0 tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-border tw-border-gray-200 tw-bg-white tw-shadow tw-ring-0 tw-transition-transform tw-duration-200 tw-ease-in-out`}></span>
        </button>
    )
}

export const Eres_inline_link = ({href, className, children, target, rel} : PropsWithChildren<{href : string, className? : string, target? : string, rel? : string}>) => {
    return <a href={href} className={`tw-text-blue-600 hover:tw-underline ${className ?? ""}`} target={target} rel={rel}>{children}</a>
}

export const Eres_spinner = ({className} : {className? : string}) => {
    return (
    <svg aria-hidden="true" className={`tw-inline-block tw-animate-spin tw-text-gray-200 tw-fill-big-stone-400 ${className || ""}}`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>)
}

export const Eres_info_badge = ({children} : PropsWithChildren<{}>) => {
    // dark:tw-bg-gray-700 dark:tw-text-green-400
    return (<span
        className="tw-bg-green-100 tw-text-green-800 tw-text-xs tw-font-semibold tw-me-2 tw-px-2.5 tw-py-0.5 tw-rounded tw-border tw-border-green-400">
        {children}</span>)
}

export const Eres_danger_badge = ({children} : PropsWithChildren<{}>) => {
    return (<span
        className="tw-bg-red-100 tw-text-red-800 tw-text-xs tw-font-semibold tw-me-2 tw-px-2.5 tw-py-0.5 tw-rounded tw-border tw-border-red-400">
        {children}</span>)
}

export const Eres_warning_badge = ({children} : PropsWithChildren<{}>) => {
    return (<span
        className="tw-bg-orange-100 tw-text-orange-800 tw-text-xs tw-font-semibold tw-px-2.5 tw-py-0.5 tw-rounded tw-border tw-border-orange-400">
        {children}</span>)
}


const button_styles = "tw-bg-big-stone-950 tw-h-10 hover:tw-bg-big-stone-900 tw-py-2.5 tw-px-5 tw-text-sm tw-text-white tw-font-bold tw-rounded-md disabled:tw-bg-gray-400 disabled:tw-text-gray-600 tw-whitespace-nowrap"
type eres_common_button_props<t> = PropsWithChildren<{
    id? : string,
    className? : string,
    onClick? : React.MouseEventHandler<t>,
    tabIndex? : number,
    type? : "submit" | "reset" | "button",
    disabled? : boolean,
}>
type eres_button_props = eres_common_button_props<HTMLButtonElement>
type eres_iconbutton_props = {
    icon? : IconProp | "eres-spinner",
}
type eres_iconbutton_link_props = eres_common_button_props<HTMLAnchorElement> & eres_iconbutton_props & { href : string }

interface eres_wizard_button_props {
    type?: "button" | "submit"
    className?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    disabled?: boolean
    children?: React.ReactNode
}

export const Eres_button = ({className, children, ...remaining_props} : eres_button_props) => {
    return <button {...remaining_props} className={`${button_styles} ${className || ""}`}> {children}</button>
}

const button_icon = (icon : IconProp | "eres-spinner" | undefined) : React.ReactNode | null => {
    return icon === undefined ? null
        : icon === "eres-spinner" ? <Eres_spinner className="tw-me-2 svg-inline--fa tw-w-[1em] tw-h-[1em] "/>
        : <FontAwesomeIcon icon={icon} className="tw-me-2" aria-hidden="true"/>
}

export const Eres_iconbutton = ({icon, children, ...remaining_props} : eres_button_props & eres_iconbutton_props) => {
    return <Eres_button {...remaining_props}>{button_icon(icon)}{children}</Eres_button>
}

export const Eres_iconbutton_link = (p : eres_iconbutton_link_props) => {
    return (<Link id={p.id} to={p.href} tabIndex={p.tabIndex} className={`${button_styles} tw-inline-block ${p.className || ""}`}>{button_icon(p.icon)}{p.children}</Link>)
}

export const Eres_wizard_button = (p: eres_wizard_button_props) => {
    const newButtonStyles = "tw-inline-block tw-px-6 tw-py-3 tw-mb-0 tw-ml-auto tw-font-bold tw-text-right tw-text-white tw-uppercase tw-align-middle tw-transition-all tw-border-0 tw-rounded-md tw-cursor-pointer tw-hover:scale-102 tw-active:opacity-85 tw-hover:shadow-soft-xs tw-dark:tw-bg-gradient-to-tl tw-dark:tw-from-slate-850 tw-dark:tw-to-gray-850 tw-bg-gradient-to-tl tw-from-gray-900 tw-to-slate-800 tw-leading-pro tw-text-xs tw-ease-soft-in tw-tracking-tight-soft tw-shadow-soft-md tw-bg-150 tw-bg-x-25 tw-whitespace-nowrap"

    const combinedClasses = `${newButtonStyles} ${p.className || ""}`

    return (
        <button type={p.type} className={combinedClasses} onClick={p.onClick} disabled={p.disabled}>
            {p.children}
        </button>
    )
}

export const form_element_styles = "tw-bg-white tw-rounded tw-border tw-border-control-border disabled:tw-bg-gray-200 disabled:tw-text-gray-600 disabled:hover:tw-border-control-border hover:tw-border-gray-400 tw-ring-0 disabled:tw-ring-0 disabled:focus:tw-ring-0 focus:tw-ring-0 focus:tw-outline-0 focus:tw-border-focus-blue"
export const file_button_styles = "tw-bg-big-stone-950 tw-h-full tw-rounded-tl tw-rounded-bl hover:tw-bg-big-stone-900 tw-py-2 tw-px-5 tw-text-sm tw-text-white disabled:tw-bg-gray-400 disabled:tw-text-gray-600 tw-ring-0 focus:tw-border-focus-blue"

type eres_checkbox_props = {
    id : string,
    "aria-describedby"? : string,
    defaultChecked? : boolean,
    name? : string,
    className? : string,
    onChange? : (e : React.ChangeEvent<HTMLInputElement>) => void,
    disabled? : boolean,
}
export const Eres_checkbox = (p : eres_checkbox_props) => {
    return (
    <input
        id={p.id}
        aria-describedby={p["aria-describedby"]}
        name={p.name}
        defaultChecked={p.defaultChecked === undefined ? false : p.defaultChecked}
        type="checkbox"
        className={`tw-transition tw-h-4 tw-w-4 tw-m-0 tw-p-0 tw-text-big-stone-900 disabled:hover:tw-bg-gray-200 ${form_element_styles} ${p.className ?? ""}`}
        onChange={p.onChange}
        disabled={p.disabled}
    />)
}

type eres_line_edit_props = {
    id? : string,
    type : "text" | "email" | "password",
    defaultValue? : string,
    "aria-label" : string,
    className? : string,
    placeholder? : string,
    onChange? : (e : React.ChangeEvent<HTMLInputElement>) => void,
    required? : boolean,
    style?: React.CSSProperties,
    extra?: React.HTMLAttributes<HTMLInputElement>
}
const _Eres_line_edit = forwardRef<HTMLInputElement, eres_line_edit_props>((props, ref) => {
    const {extra, ...remaining_props} = props
    return (
    <input
        ref={ref}
        className="tw-block tw-w-full tw-rounded-md tw-border-0 tw-py-1.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-indigo-600 sm:tw-text-sm sm:tw-leading-6"
        {...remaining_props}
        {...extra}
    />
    );
});

_Eres_line_edit.displayName = 'Eres_line_edit';

export const Eres_line_edit = React.memo(_Eres_line_edit)

export const Eres_form_error = ({msg, className} : {msg : string, className? : string}) => {
    return <p className={`tw-mt-2 tw-text-sm tw-font-normal tw-text-danger2 ${className ?? ""}`}>{msg}</p>
}

export const Eres_form_label = ({htmlFor, className, children, required} : PropsWithChildren<{htmlFor : string, className? : string, required? : boolean}>) => {
    return <label
        htmlFor={htmlFor}
        className={`tw-text-sm tw-font-semibold tw-text-big-stone-900 ${className ?? ""}`}>
            {children}
            {required && <span className="tw-text-red-500">*</span>}
    </label>
}

export const Eres_form_toplabel = ({htmlFor, className, children} : PropsWithChildren<{htmlFor : string, className? : string}>) => {
    return <Eres_form_label htmlFor={htmlFor} className={`tw-mb-1.5 ${className ?? ""}`}>{children}</Eres_form_label>
}

export const Eres_file_input = ({default_file_name, on_change, show_size_limit = true}: {default_file_name?: string, on_change: ((event: React.ChangeEvent<HTMLInputElement>) => void), show_size_limit?: boolean}) => {
    const [file_name, set_file_name] = useState<string>('');
    const [file_error, set_file_error] = useState<string | null>(null);

    // The caption under this control promises "image or video" and a 100MB
    // limit; neither was enforced, so an oversized or wrong-typed file was only
    // rejected later by the upload, or by facebook.
    const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;

    const handle_file_change = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            if (!file.type.startsWith('image/') && !file.type.startsWith('video/')) {
                set_file_error('Choose an image or a video.');
                set_file_name('');
                event.target.value = '';
                return;
            }
            if (file.size > MAX_UPLOAD_BYTES) {
                const mb = Math.round(file.size / (1024 * 1024));
                set_file_error(`That file is ${mb}MB. The limit is 100MB.`);
                set_file_name('');
                event.target.value = '';
                return;
            }
            set_file_error(null);
            set_file_name(file.name);
        } else {
            set_file_error(null);
            set_file_name('');
        }
        on_change && on_change(event);
    };

    useEffect(() => {
        default_file_name && set_file_name(default_file_name)
    }, [default_file_name])

    return (
    <div>
        <div className={`tw-flex tw-items-center tw-rounded ${form_element_styles}`}>
            <div className={`tw-w-32 tw-rounded-tl tw-rounded-bl tw-text-gray-900 tw-bg-gray-50`}>
            <label htmlFor="file_input" className={`tw-text-center tw-cursor-pointer tw-block tw-truncate ${file_button_styles}`}>
                Choose File
            </label>
            <input
                id="file_input"
                type="file"
                accept="image/*,video/*"
                className="tw-hidden"
                onChange={handle_file_change}
            />
            </div>
            {file_name && (
            <div className="tw-text-sm tw-ml-2 tw-text-gray-700">
                {file_name}
            </div>
            )}
        </div>
        {file_error && (
            <div role="alert" className="tw-text-xs tw-text-red-700 tw-mt-1">{file_error}</div>
        )}
        {show_size_limit && (
            <div className="tw-text-xs tw-text-gray-500 tw-mt-1 tw-flex tw-gap-2">
                <span>Upload image or video</span>
                <span>•</span>
                <span>Maximum file size: 100MB</span>
            </div>
        )}
    </div>
    );
};


export type eres_card_params = PropsWithChildren<{
    className? : string,
    onClick? : (e : React.MouseEvent<HTMLElement>) => void,
}>
export const Eres_card = ({children, className, ...remaining_fields} : eres_card_params) => {
    return (<div className={`tw-bg-white tw-border tw-border-gray-200 tw-rounded-md tw-shadow-sm tw-text-lynch-500 ${className ?? ""}`} {...remaining_fields}>
        {children}</div>)
}

export const Eres_bare_card = ({children, className} : React.PropsWithChildren<{className? : string}>) => {
    return (<div className={`tw-border-0 tw-bg-transparent tw-text-lynch-500 ${className ?? ""}`}>{children}</div>)
}

export const Eres_hline = ({className} : React.PropsWithChildren<{className? : string}>) => <hr className={`tw-border-0 tw-border-t tw-border-lynch-500 ${className || ""}`} />

export const Eres_spin_placeholder = ({className} : {className? : string}) => {
    return <div className={`tw-w-full tw-h-full tw-text-center tw-align-middle ${className || ""}`}><Eres_spinner className="tw-w-6 tw-h-6"/></div>
}

export const Eres_card_medium = ({children} : PropsWithChildren<{}>) => {
        return (<div className="tw-bg-white tw-border tw-border-gray-200 tw-rounded-md tw-shadow-sm tw-w-1/2">
                {children}</div>)
}

export const stop_propagation = (e : React.BaseSyntheticEvent<any>) => { e.stopPropagation() }

export type eres_modal_params = PropsWithChildren<{
    button_strip : React.ReactElement | null,
    title : string,
    on_cancel : () => void,
}>

export type eres_header_params = PropsWithChildren<{
    className? : string,
}>
export const Eres_headerlg = ({children, className} : eres_header_params) => {
    return <h3 className={`tw-text-lg tw-font-bold tw-tracking-trkheader tw-text-big-stone-950 ${className || ""}`}>{children}</h3>
}

export const Eres_headerxl = ({children, className} : eres_header_params) => {
    return <h3 className={`tw-text-xl tw-font-bold tw-tracking-trkheader tw-text-big-stone-950 ${className || ""}`}>{children}</h3>
}

export const Eres_header2xl = ({children, className} : eres_header_params) => {
    return <h3 className={`tw-text-2xl tw-font-bold tw-tracking-trkheader tw-text-big-stone-950 ${className || ""}`}>{children}</h3>
}

export const Eres_modal = ({button_strip, title, on_cancel, children} : eres_modal_params) => {
    return (
    <FocusTrap focusTrapOptions={{returnFocusOnDeactivate : true, escapeDeactivates : true, onDeactivate : on_cancel}}>
    <div tabIndex={-1} aria-hidden="true" onClick={on_cancel} className="tw-overflow-y-auto tw-overflow-x-hidden tw-fixed tw-flex tw-top-0 tw-right-0 tw-left-0 tw-z-50 tw-justify-center tw-items-center tw-w-full md:tw-inset-0 tw-h-[calc(100%)] tw-max-h-full tw-bg-gray-500 tw-bg-opacity-75 tw-backdrop-blur">
        <div className="tw-relative tw-p-4 tw-w-full tw-max-w-2xl tw-max-h-full">
            <Eres_card onClick={stop_propagation}>
                <div className="tw-flex tw-items-center tw-justify-between tw-p-4 md:tw-p-5 tw-border-b tw-rounded-t tw-border-gray-200">
                    <Eres_headerxl>{title}</Eres_headerxl>
                    <button tabIndex={-1} type="button" onClick={on_cancel} className="tw-text-gray-400 tw-bg-transparent hover:tw-bg-gray-200 hover:tw-text-gray-900 tw-rounded-lg tw-text-sm tw-w-8 tw-h-8 tw-ms-auto tw-inline-flex tw-justify-center tw-items-center">
                        <svg className="tw-w-3 tw-h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span className="tw-sr-only">Close modal</span>
                    </button>
                </div>
                {children === undefined ? null : <div className="tw-p-4 md:tw-p-5 tw-space-y-4">{children}</div>}
                <div className="tw-p-4 md:tw-p-5 tw-border-t tw-border-gray-200 tw-rounded-b">{button_strip}</div>
            </Eres_card>
        </div>
    </div>
    </FocusTrap>)
}

export const asc : unique symbol = Symbol("asc")
export const desc : unique symbol = Symbol("desc")
export type ascdesc_t = typeof asc | typeof desc
export const nosort : unique symbol = Symbol.for("nosort")
export type cmpfn<t> = (x : t, y : t) => number
export type header_description<t> = [string, string, string, typeof nosort | cmpfn<t>]

const Emit_header_column = <t,>(sortinfo : [ascdesc_t, string], [key, label, width, can_sort] : header_description<t>) => {
    const [ascdesc, sortkey] = sortinfo
    const nextorder = sortkey !== key ? asc : (ascdesc === asc ? desc : asc)
    const sortlink = `/connected-networks?cn-sort=${nextorder === asc ? "asc" : "desc"}-${key}`
    const _label = can_sort !== nosort ? <Link to={sortlink} className="dataTable-sorter" replace={true}>{label}</Link> : label
    const css_style = {width : width}
    return <th key={key} className="tw-px-1.5 first:tw-ps-6 last:tw-pe-6 tw-py-4 tw-text-xs tw-font-bold tw-opacity-75" style={css_style}>{_label}</th>
}

const Emit_table_header = <t,>({headers, sortinfo} : {headers : header_description<t>[], sortinfo : [ascdesc_t, string]}) => {
    return (
        <thead className="tw-bg-gray-50">
        <tr className="">{headers.map((i) => Emit_header_column(sortinfo, i))}</tr>
        </thead>)
}

export const eres_prepare_table = <t,>(headers : header_description<t>[]) : {
    readonly headers : header_description<t>[],
    readonly sorts : Map<string, cmpfn<t>>,
} => {
    const sorts = new Map<string, cmpfn<t>>()
    for (const [id, , , cmp] of headers) { if (cmp !== nosort) sorts.set(id, cmp) }
    return { headers, sorts }
}

export const Eres_basic_tablecol = ({children, align} : PropsWithChildren<{align? : "right"}>) => {
    return <td className={`tw-whitespace-nowrap tw-px-1.5 first:tw-ps-6 last:tw-pe-6 tw-py-1.5 tw-text-sm ${align === "right" ? "tw-text-right" : ""}`}>{children}</td>
}
type eres_basic_table_props<t> = React.PropsWithChildren<{
    headers : header_description<t>[],
    footer? : React.ReactNode | null,
}>
export const Eres_basic_table = <t,>({headers, footer, children} : eres_basic_table_props<t>) => {
    const sort_dir : ascdesc_t = asc
    const sort_id = "XXXih fixme"
    return (
    <div className="tw-overflow-x-auto tw-mt-3">
        <div className="">
            <table className="tw-w-full tw-border-y tw-mb-3 tw-table-auto">
            <Emit_table_header headers={headers} sortinfo={[sort_dir, sort_id]}/>
            <tbody>
                {children}
            </tbody>
            </table>
        </div>
        {footer
            ? <div className="tw-pb-3 tw-px-6 tw-text-sm tw-text-lynch-600">{footer}</div>
            : null}
    </div>)
}


interface TabProps {
    defaultTab: number
    tabs: TabItem[]
}

export interface TabItem {
    id: number
    icon: IconDefinition
    label: string
    content: React.ReactNode
}

export const Eres_tab = ({ defaultTab, tabs } : TabProps) => {
    const [active_tab, set_active_tab] = useState<number>(defaultTab)
    const is_active = (id: number) => id === active_tab ? "tw-border-blue-600 tw-text-blue-600" : "tw-text-gray-500 tw-dark:text-gray-400"

    return (
        <>
        <div className="tw-border-b tw-border-gray-200 tw-dark:border-gray-700">
            <ul className="tw-flex tw-flex-wrap tw--mb-px tw-text-sm tw-font-medium tw-text-center tw-text-gray-500 ">
                    {tabs.map(tab => (
                        <li key={tab.id} className="tw-me-2">
                        <a
                            href="#"
                            onClick={() => set_active_tab(tab.id)}
                            className={`tw-inline-flex tw-items-center tw-justify-center tw-p-4 tw-border-b-2 tw-rounded-t-lg tw-hover:text-gray-600 tw-hover:border-gray-300 tw-group ${is_active(tab.id)}`}>
                            <FontAwesomeIcon icon={tab.icon} aria-hidden="true" className="tw-pe-1"/>{tab.label}
                        </a>
                        </li>
                    ))}
            </ul>
        </div>
        {tabs.map(tab => (
            active_tab === tab.id && (
                <div key={tab.id}>
                    {tab.content}
                </div>
            )
        ))}
        </>
    )
}


export const Eres_collapse = ({title, open = false, children} : PropsWithChildren<{title : string, open? : boolean}>) => {
    const [is_open, set_is_open] = useState<boolean>(open)

    const toggle_collapse = () => {
        set_is_open(!is_open)
    }

    return (
        <div className="tw-w-full">
            <div className="tw-text-sm tw-font-semibold tw-text-big-stone-900 tw-cursor-pointer" onClick={toggle_collapse}>
                <FontAwesomeIcon className='tw-mr-2' icon={is_open ? faChevronDown : faChevronRight} />
                {title}
            </div>
            {is_open && (
                <div className="tw-w-full">
                    {children}
                </div>
            )}
        </div>
    )
}

export type eres_alert_props = PropsWithChildren<{className? : string}>
export const Eres_alert = React.memo(({children, className} : eres_alert_props) => {
    return <div className={`tw-p-4 tw-w-full tw-rounded ${className ?? ""}`}>{children}</div>
})

/******************************************************************************
 ** Combo box with text input filtering [
 ******************************************************************************/

const do_nothing = () => {}
let ro_cb : () => void = do_nothing
const ro = new ResizeObserver((entries, observer) => { void entries; void observer; ro_cb() })
const lookup_default = (xs : Map<string, [string, string]>, k : string | null, def : string) : [boolean, string] => {
    if (k === null) return [false, def]
    const v = xs.get(k)
    if (v === undefined) return [false, def]
    return [true, v[0]]
}

type keystring = string
type combobox_props = {
    id : string,
    data : {key : keystring, display : string, icon?: IconDefinition}[],
    empty_selection_text : string,
    search_placeholder : string,
    unselect_placeholder : string,
    no_matches_placeholder : string,
    defaultValue? : keystring,
    onBlur? : React.FocusEventHandler<combobox_elt>, // This is an HTML-style event handler. See Note [emulated_html_form_elements].
    onChange? : (new_key : keystring | null) => void, // This is a "controlled component"-style event handler. See Note [emulated_html_form_elements].
    name? : string | undefined,
    onSearch?: (query: string) => void,
    maxHeight?: string;
    showScrollIndicator?: boolean;
    isLoading?: boolean;
}

const combo_item_styles = "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-outline-none aria-selected:tw-bg-slate-700 aria-selected:tw-text-slate-100 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50"

const event_handle_for_unsubscribe = Symbol.for("__eres-usu")

/*
 * Note [emulated_html_form_elements]
 *
 * in an ideal world, we'd be able to use support for custom html elements to
 * create a custom combobox element that participates fully in the normal html
 * form event protocol. support for CustomElementRegistry has been around in all
 * the large desktop and mobile browsers since 2016 [1], but ElementInternals,
 * the api we'd use to integrate into normal browser form processing, was added
 * in 2022-2023 [2]. most importantly the 2016 iphone se doesn't support this,
 * because ios safari gained support for ElementInternals in 16.4, but the 1st
 * gen iPhone SE runs 15.x and nothing later. there are "polyfills" for this [3]
 * which might be worth playing around with later
 *
 * [1] https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry
 *
 * [2] https://developer.mozilla.org/en-US/docs/Web/API/ElementInternals
 *
 * [3] https://www.npmjs.com/package/element-internals-polyfill
 */

type combobox_dom_properties = { __eres_combokey : string | undefined, __eres_combotag : true, [event_handle_for_unsubscribe] : () => void, ____eres_dispatching_blur : boolean }
export type combobox_elt = Element & combobox_dom_properties
const _Eres_combobox = React.forwardRef<combobox_elt, combobox_props>((props, ref) : React.ReactElement => {
    const {
        id, data, defaultValue, empty_selection_text,
        search_placeholder, unselect_placeholder, no_matches_placeholder,
        onBlur, onChange, name, onSearch,
        maxHeight = '300px',
        showScrollIndicator = true,
        isLoading = false,
    } = props
    type internal_combo_elt = HTMLButtonElement & combobox_dom_properties
    type combobox_internal_focus_state = "no-focus" | "trigger-has-focus" | "focus-transition-to-trigger" | "popover-has-focus"
    type combobox_internal_state = {
        button_ref : null | internal_combo_elt,
        popover_ref : null | HTMLDivElement,
        default_value_ref : string | undefined,
        focus_state_ref : combobox_internal_focus_state,
        open : boolean,
        set_button_ref : (elt : null | HTMLButtonElement) => void,
        set_popover_ref : (popover_elt : null | HTMLDivElement) => void,
        resizeobserver_cb : () => void,
    }
    const internal_state = React.useRef(null as unknown as combobox_internal_state)
    if (internal_state.current === null) {
        const set_button_ref = (elt : null | HTMLButtonElement) => {
            const is = internal_state.current
            if (elt === null) {
                if (is.button_ref === null) {
                    console.warn("unexpected cbox set_button_ref null/null d52af348fd40d729")
                    return
                }
                const e = is.button_ref as Partial<internal_combo_elt>
                const form = e.form
                const ehdl = e[event_handle_for_unsubscribe]
                if (form !== null && form !== undefined && ehdl) form.removeEventListener("reset", ehdl)
                is.button_ref = null
                if (ref !== null) {
                    if (typeof ref === 'function') ref(null)
                    else (ref as React.MutableRefObject<combobox_elt | null>).current = null
                }
                return
            }
            if (is.button_ref !== null) console.warn("unexpected cbox set_button_ref notnull/null 37aa744dd9b3f3f0")
            const e = elt as Partial<internal_combo_elt>
            e.__eres_combotag = true
            if (!('__eres_combokey' in e)) {
                e.__eres_combokey = undefined
            }
            e.value = undefined
            e.____eres_dispatching_blur = false
            e[event_handle_for_unsubscribe] = reset_to_default
            set_force_update_ctr(_force_update_ctr + 1)
            const form = e.form
            if (form !== null && form !== undefined) form.addEventListener("reset", reset_to_default)
            is.button_ref = e as internal_combo_elt
            if (ref !== undefined && ref !== null) {
                    if (typeof ref === 'function') ref(e as combobox_elt)
                    else (ref as React.MutableRefObject<combobox_elt | null>).current = e as combobox_elt
            }
        }
        const set_popover_ref = (popover_elt : null | HTMLDivElement) => {
            const is = internal_state.current
            if (popover_elt === null) {
                is.popover_ref = null
                set_open_style("")
            } else {
                if (is.popover_ref !== popover_elt) {
                    is.popover_ref = popover_elt
                    let open_style = "tw-rounded-none tw-rounded-t tw-border-gray-400"
                    let side : "bottom" | "top" = "bottom"
                    if (popover_elt.attributes.getNamedItem("data-side")?.value === "top") {
                        open_style = "tw-rounded-none tw-rounded-b tw-border-gray-400"
                        side = "top"
                    }
                    set_open_style(open_style)
                    set_side(side)
                }
            }
        }
        internal_state.current = {
            button_ref : null,
            popover_ref : null,
            default_value_ref : defaultValue,
            focus_state_ref : "no-focus",
            open : false,
            set_button_ref,
            set_popover_ref,
            resizeobserver_cb : () => {
                const is = internal_state.current
                if (is.popover_ref !== null && is.button_ref !== null) {
                    const rect = is.button_ref.getBoundingClientRect()
                    is.popover_ref.style.width = `${rect.width}px`
                }
            },
        }
    }
    const k2v = React.useMemo(() => {
        const m = new Map<string, [string, string]>()
        for (const {key, display} of data) m.set(key.toLowerCase(), [display, display.toLowerCase()])
        m.set("--unselect--", [unselect_placeholder, unselect_placeholder.toLowerCase()])
        return m
    }, [data])
    const [open, set_open] = React.useState(false)
    const [_force_update_ctr, set_force_update_ctr] = React.useState(0)
    const [current_key, set_current_key] = React.useState(() : null | string => {
        if (defaultValue === undefined) return null
        else if (k2v.has(defaultValue)) return defaultValue
        else return null
    })
    const handle_keypress = React.useCallback((e : React.KeyboardEvent) => {
        if (open) return
        if (e.code === "ArrowDown") { e.preventDefault(); set_open(true) }
    }, [open])
    React.useEffect(() => {
        const is = internal_state.current
        if (is.button_ref !== null) {
            const btn = is.button_ref
            const next_key = current_key ?? undefined
            btn.__eres_combokey = next_key
            btn.value = next_key as string
        }
    }, [current_key])
    const reset_to_default = React.useCallback(() => {
        const is = internal_state.current
        const dval = is.default_value_ref
        const sel = dval ?? null
        set_current_key(sel)
    }, [])
    React.useEffect(() => {
        const is = internal_state.current
        is.default_value_ref = defaultValue
        let next : null | string
        if (defaultValue === undefined) next = null
        else if (k2v.has(defaultValue)) next = defaultValue
        else next = null
        if (next !== current_key) {
            set_current_key(next)
        }
    }, [defaultValue])
    const on_select = React.useCallback((selected_key : string) => {
        let sel : string | null = selected_key
        if (selected_key === "--unselect--") sel = null
        if (sel !== current_key) {
            set_current_key(sel)
            if (onChange !== undefined) onChange(sel);
        }
        set_open(false)
    }, [current_key])
    React.useEffect(() => {
        const is = internal_state.current
        if (is.button_ref === null) return
        if (open) {
            ro_cb = is.resizeobserver_cb
            ro.observe(is.button_ref)
        } else {
            if (ro_cb === is.resizeobserver_cb) ro_cb = do_nothing
            ro.unobserve(is.button_ref)
        }
    }, [open])
    React.useEffect(() => {
        const is = internal_state.current
        if (ro_cb === is.resizeobserver_cb) ro_cb = do_nothing
        if (is.button_ref) ro.unobserve(is.button_ref)
    }, [])
    const filter_entries = React.useCallback((key : string, query : string) => {
        const val = k2v.get(key)
        if (val === undefined) return 0
        const [, lc] = val
        const qlc = query.toLowerCase()
        if (lc.includes(qlc)) return 1
        return 0
    }, [k2v])
    const button_label = React.useMemo(() => {
        const [real_val, val] = lookup_default(k2v, current_key, empty_selection_text)
        if (real_val) return val
        return <span className="tw-text-lynch-300">{val}</span>
    }, [current_key, empty_selection_text])
    const [side, set_side] = React.useState<"bottom" | "top">("bottom")
    const [open_style, set_open_style] = React.useState("")
    const set_focus_state = React.useCallback((next_focus_state : combobox_internal_focus_state) => {
        const is = internal_state.current
        const old = is.focus_state_ref
        if (next_focus_state === "focus-transition-to-trigger" && old === "no-focus") return
        if (next_focus_state === "no-focus" && old !== "no-focus") {
            if (is.button_ref !== null) {
                const evt : FocusEvent = new FocusEvent("focusout", {bubbles : true, cancelable : true})
                is.button_ref.____eres_dispatching_blur = true
                is.button_ref.dispatchEvent(evt)
            }
        }
        is.focus_state_ref = next_focus_state
    }, [])
    const handleSearchChange = useCallback((value: string) => {
        if (onSearch) {
            onSearch(value);
        }
    }, [onSearch]);

    const [inputValue, setInputValue] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    const filteredData = React.useMemo(() => {
        const filtered = data.filter(item => filter_entries(item.key, inputValue));
        return filtered;
    }, [data, inputValue, filter_entries]);

    const handleKeyDown = (event: React.KeyboardEvent) => {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                setHighlightedIndex(prev => (prev + 1) % filteredData.length);
                break;
            case 'ArrowUp':
                event.preventDefault();
                setHighlightedIndex(prev => (prev - 1 + filteredData.length) % filteredData.length);
                break;
            case 'Enter':
                if (highlightedIndex !== -1) {
                    on_select(filteredData[highlightedIndex].key);
                }
                break;
        }
    };

    return (
    <RP.Root open={open} onOpenChange={set_open}>
        <RP.Trigger asChild
            className={`tw-w-full tw-inline-flex tw-items-center tw-justify-between tw-whitespace-nowrap tw-rounded tw-transition-colors tw-h-9 tw-px-3 ${form_element_styles} ${open_style}`}
            onKeyDown={handle_keypress}
        >
            <button
                role="combobox" aria-expanded={open} ref={internal_state.current.set_button_ref} id={id} name={name}
                onBlur={e => {
                    const is = internal_state.current
                    if (e.target === is.button_ref) {
                        if (is.button_ref.____eres_dispatching_blur) {
                            is.button_ref.____eres_dispatching_blur = false
                            if (onBlur !== undefined) onBlur(e as unknown as React.FocusEvent<combobox_elt>);
                            return
                        }
                    }
                    e.stopPropagation();
                    if (is.focus_state_ref === "popover-has-focus") return;
                    set_focus_state("no-focus");
                }}
                onFocus={() => { set_focus_state("trigger-has-focus") }}
                >
                {button_label}
                <FontAwesomeIcon icon={faChevronDown} className="tw-w-3 tw-h-3" />
            </button>
        </RP.Trigger>
        <RP.Content
            className={`tw-w-72 data-[side=bottom]:tw-rounded-b data-[side=top]:tw-rounded-t tw-border-l tw-border-r data-[side=bottom]:tw-border-b data-[side=top]:tw-border-t tw-text-slate-500 ${side === "bottom" ? "tw-shadow-lg" : "tw-shadow-toplg"} tw-outline-none tw-bg-white tw-p-0 tw-border-gray-400 data-[state=open]:tw-animate-in data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2`}
            align="start" sideOffset={0} ref={internal_state.current.set_popover_ref}
            onCloseAutoFocus={(e) => { set_focus_state("focus-transition-to-trigger") }}
            onOpenAutoFocus={() => { set_focus_state("popover-has-focus") }}
            onInteractOutside={(e) => {
                const is = internal_state.current
                const btn = is.button_ref
                const tgt = e.target
                const is_moving_to_trigger = btn !== null && tgt !== null && tgt instanceof Element && btn.contains(tgt)
                if (!is_moving_to_trigger) set_focus_state("no-focus")
            }}
            >
        {!open ? null : (
        <Cmdk loop filter={filter_entries} defaultValue={current_key ?? undefined} onKeyDown={handleKeyDown}>
            {side === "bottom" ? (
                <div key="fltinput" className="tw-w-full tw-px-3">
                    <div className={`tw-w-full ${side === "bottom" ? "tw-border-b" : "tw-border-t"} tw-flex tw-items-center tw-gap-2`}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} className="tw-h-3 tw-w-3" />
                        <Cmdk.Input 
                            role="combobox" 
                            aria-expanded={open} 
                            placeholder={search_placeholder}
                            className={`tw-transition tw-h-9 tw-m-0 tw-p-0 tw-text-black tw-font-normal tw-text-fs-inherit ${form_element_styles} tw-rounded-none tw-border-none tw-ring-0 tw-w-full tw-display-inline-block`}
                            onValueChange={(value) => {
                                setInputValue(value);
                                handleSearchChange(value);
                            }}
                        />
                    </div>
                </div>
            ) : null}
            {isLoading && (
                <Cmdk.Loading className="tw-py-6 tw-text-center">
                    <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                        <Eres_spinner className="tw-w-4 tw-h-4" />
                        <span>Searching...</span>
                    </div>
                </Cmdk.Loading>
            )}
            {!isLoading && filteredData.length === 0 && (
                <Cmdk.Empty className="tw-py-6 tw-text-center">
                    {no_matches_placeholder}
                </Cmdk.Empty>
            )}
            <div 
                className={`tw-max-h-[${maxHeight}] ${showScrollIndicator ? 'tw-overflow-y-auto' : 'tw-overflow-y-hidden'}`}
                style={{ overflowY: 'auto', maxHeight: maxHeight }}
            >
                <Cmdk.List>
                    {filteredData.map(({key, display, icon}, index) => (
                        <Cmdk.Item 
                            key={key} 
                            value={key} 
                            onSelect={() => on_select(key)}
                            className={`${combo_item_styles} ${index === highlightedIndex ? 'tw-bg-slate-700 tw-text-slate-100' : ''}`}
                        >
                            {icon && <FontAwesomeIcon icon={icon} className="tw-mr-2" />}
                            {display}
                            {key === current_key ? <FontAwesomeIcon icon={faCheck} className="tw-h-3 tw-w-3 tw-ms-auto"/> : null}
                        </Cmdk.Item>
                    ))}
                </Cmdk.List>
            </div>
            {side === "top" ? (
                <div key="fltinput" className="tw-w-full tw-px-3">
                    <div className={`tw-w-full ${side === "top" ? "tw-border-t" : "tw-border-b"} tw-flex tw-items-center tw-gap-2`}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} className="tw-h-3 tw-w-3" />
                        <Cmdk.Input 
                            role="combobox" 
                            aria-expanded={open} 
                            placeholder={search_placeholder}
                            className={`tw-transition tw-h-9 tw-m-0 tw-p-0 tw-text-black tw-font-normal tw-text-fs-inherit ${form_element_styles} tw-rounded-none tw-border-none tw-ring-0 tw-w-full tw-display-inline-block`}
                            onValueChange={(value) => {
                                setInputValue(value);
                                handleSearchChange(value);
                            }}
                        />
                    </div>
                </div>
            ) : null}
        </Cmdk>)}
        </RP.Content>
    </RP.Root>
    )
})
export const Eres_combobox = React.memo(_Eres_combobox)

export const is_combobox = (element : Element) : element is combobox_elt => {
    return '__eres_combotag' in element && (element as any).__eres_combotag === true
}

/******************************************************************************
 ** Combo box with text input filtering ]
 ******************************************************************************/
export interface step_meta {
    title: string,
    content: React.ReactNode,
}


export const Eres_stepper = ({steps, active, on_step_click} : {steps: step_meta[], active : number, on_step_click : (step : number) => void}) => {
    const is_active = (id: number) => id === active ? "tw-text-blue-600 tw-dark:text-blue-500" : ""
    const is_circle_active = (id: number) => id === active ? "tw-border-blue-600" : "tw-border-gray-500"

    return (
        <>
        <Eres_card>
        <ol className="tw-rounded-md tw-flex tw-items-center tw-w-full tw-p-3 tw-space-x-2 tw-text-sm tw-font-medium tw-text-center tw-text-gray-500 tw-bg-white tw-sm:text-base tw-sm:p-4 tw-sm:space-x-4">
            <div className='tw-mx-auto tw-flex tw-space-x-2'>
                {steps.map((step, index) => (
                    <li key={index} onClick={ () => on_step_click(index) } className={`tw-cursor-pointer tw-flex tw-items-center ${is_active(index)}`}>
                        <span className={`tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-me-2 tw-text-xs tw-border tw-rounded-full tw-shrink-0 ${is_circle_active(index)}`}>
                            {index + 1}
                        </span>
                        {step.title}
                        { index < steps.length - 1 &&
                         <FontAwesomeIcon className='tw-ml-1' icon={faAnglesRight} />
                        }
                    </li>
                ))}
            </div>
        </ol>
        </Eres_card>
        <div className='tw-mb-2'></div>
        <Eres_card >
            <div className="tw-p-3">
                {steps[active].content}
            </div>
        </Eres_card>
        </>
    )
}


export const Eres_code_snippet = ({code} : {code: string}) => {
    return (
        <pre className="tw-font-mono tw-my-4 tw-p-4 tw-bg-gray-800 tw-rounded-lg tw-shadow-lg tw-text-white tw-overflow-x-auto">
            <code className="tw-whitespace-pre">{code}</code>
        </pre>
    )
}


// very simple tooltip with position to the right
export const Eres_tooltip : React.FC<PropsWithChildren<{text : string}>> = ({ text, children }) => {
    const [show_tooltip, set_show_tooltip] = useState(false);
    return (
        <div className="tw-relative tw-inline-block">
            <span
                onMouseEnter={() => set_show_tooltip(true)}
                onMouseLeave={() => set_show_tooltip(false)}
                className="tw-cursor-pointer"
            >
                {children}
            </span>
            {show_tooltip && (
                <div className="tw-absolute tw-z-50 tw-w-max tw-bg-black tw-text-white tw-px-2 tw-py-1 tw-rounded-md tw-shadow-md tw-left-full tw-top-1/2 tw-transform -tw-translate-y-1/2">
                {text}
                </div>
            )}
        </div>
    )
}

/******************************************************************************
 ** multi-select combo box [
 ******************************************************************************/
 interface MultiSelectComboboxProps extends Omit<combobox_props, 'onChange' | 'defaultValue'> {
    selectedOptions: string[];
    onChange: (selected: string[]) => void;
    onSearch?: (query: string) => void;
    isLoading?: boolean;
    maxHeight?: string;
    showScrollIndicator?: boolean;
    onDataReady?: () => void;
  }
  
export const Eres_multiselect_combobox: React.FC<MultiSelectComboboxProps> = ({
  selectedOptions = [],
  onChange,
  data = [],
  onDataReady,
  ...props
}) => {
  const [currentSelection, setCurrentSelection] = useState<string[]>(selectedOptions);

  useEffect(() => {
    setCurrentSelection(selectedOptions);
  }, [selectedOptions]);

  const handleSelectChange = useCallback((selectedKey: string | null) => {
    if (selectedKey === null) return;
    setCurrentSelection(prev => {
      const newSelected = prev.includes(selectedKey)
        ? prev.filter(item => item !== selectedKey)
        : [...prev, selectedKey];
      onChange(newSelected);
      return newSelected;
    });
  }, [onChange]);

  // simple filtering without complex memoization
  const formattedData = data
    .filter(item => item && typeof item === 'object' && 'key' in item && 'display' in item)
    .filter(item => !currentSelection.includes(item.key));
  
  // simple selected item lookup
  const selectedItems = currentSelection
    .map(key => data.find(item => item.key === key))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));
  
  // call onDataReady when component has processed data and is ready to display
  useEffect(() => {
    if (onDataReady && formattedData.length > 0) {
      onDataReady();
    }
  }, [formattedData.length, onDataReady]);

  return (
    <div>
      <div className="tw-mb-2 tw-flex tw-flex-wrap tw-gap-2">
        {selectedItems.map((item) => (
          <span key={item.key} className="tw-bg-blue-100 tw-text-blue-800 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded tw-flex tw-items-center">
            {item.icon && <FontAwesomeIcon icon={item.icon as IconDefinition} className="tw-mr-1" />}
            {item.display || item.key}
            <button onClick={() => handleSelectChange(item.key)} className="tw-ml-1 tw-text-blue-600 hover:tw-text-blue-800">
              ×
            </button>
          </span>
        ))}
      </div>
      <Eres_combobox
        {...props}
        data={formattedData}
        onChange={handleSelectChange}
        empty_selection_text={currentSelection.length > 0 ? `${currentSelection.length} selected` : ""}
      />
    </div>
  );
};
  

/******************************************************************************
 * multi-select combo box ]
 * ******************************************************************************/
